import { html } from 'rune-ts';
import {
  MarppleShopLogo_creator,
  MarppleShopLogo_popup,
} from '@services/MarppleShop/shared/components/atoms/Icon/identity_icons.ts';

export const makeCreatorHeaderLeftLogo = () => {
  return html`<a href="/${ET.lang}/@/creator/ranking/realtime" style="height: 28px; color: inherit;"
    >${MarppleShopLogo_creator()}</a
  >`;
};

export const makePopupHeaderLeftLogo = () => {
  return html`<a href="/${ET.lang}/@/popup-store/" style="height: 28px; color: inherit;"
    >${MarppleShopLogo_popup()}</a
  >`;
};
